var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftImg"},[_c('img',{attrs:{"src":require("@/assets/njImgs/maskCount.png"),"alt":""}}),_c('div',{staticClass:"tiBox"},[_c('div',[_vm._v(_vm._s(_vm.stateParams.title))]),_c('div',[_vm._v(_vm._s(_vm.stateParams.count))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }